var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "edit-profile-panel" }, [
    _c(
      "div",
      { staticClass: "edit-avatar-wrapper flex-wrapper" },
      [
        _c(
          "div",
          {
            staticClass: "avatar-wrapper",
            class: { edit: _vm.avatarEditable },
            style: { background: _vm.userAvatarColor },
          },
          [
            _vm.userAvatarVisible
              ? _c("avatar", {
                  attrs: {
                    username: _vm.fullname,
                    backgroundColor: _vm.userAvatarColor || "#ff9874",
                  },
                })
              : _c("rt-picture", { attrs: { src: _vm.avatarIconPath } }),
            _vm._v(" "),
            _vm.userAvatarIcon || _vm.userAvatarColor
              ? _c(
                  "primary-button",
                  {
                    staticClass: "btn-normal btn-cancel",
                    on: { click: _vm.handleCancelAvatar },
                  },
                  [
                    _c("rt-picture", {
                      staticClass: "icon-cancel",
                      attrs: { src: "/assets/app/class/icon-cancel.svg" },
                    }),
                  ],
                  1
                )
              : _vm._e(),
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "primary-button",
          {
            ref: "avatarBtn",
            staticClass: "btn-edit-avatar",
            on: {
              click: function ($event) {
                _vm.dropdownVisible = true
              },
            },
          },
          [_vm._v(_vm._s(_vm.avatarButtonName) + "\n    ")]
        ),
        _vm._v(" "),
        _vm.dropdownVisible
          ? _c(
              "div",
              { ref: "dropdown", staticClass: "avatars-dropdown" },
              [
                _c("div", { staticClass: "avatar-group" }, [
                  _c("h2", { staticClass: "group-name" }, [
                    _vm._v("Choose an avatar"),
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "avatar-icons-wrapper" }, [
                    _c(
                      "div",
                      { staticClass: "avatar-icons" },
                      [
                        _c(
                          "div",
                          {
                            staticClass: "avatar-item",
                            class: { active: _vm.avatarIcon === "default" },
                            on: {
                              click: function ($event) {
                                _vm.avatarIcon = "default"
                              },
                            },
                          },
                          [
                            _c("avatar", {
                              attrs: {
                                username: _vm.fullname,
                                backgroundColor: _vm.avatarColor || "#ff9874",
                              },
                            }),
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _vm._l(_vm.avatarIcons, function (icon, idx) {
                          return _c(
                            "div",
                            {
                              key: idx,
                              staticClass: "avatar-item",
                              class: { active: _vm.avatarIcon === icon },
                              on: {
                                click: function ($event) {
                                  _vm.avatarIcon = icon
                                },
                              },
                            },
                            [_c("rt-picture", { attrs: { src: icon } })],
                            1
                          )
                        }),
                      ],
                      2
                    ),
                  ]),
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "avatar-group" }, [
                  _c("h2", { staticClass: "group-name" }, [
                    _vm._v("Choose background color"),
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "avatar-icons-wrapper" }, [
                    _c(
                      "div",
                      { staticClass: "avatar-icons" },
                      _vm._l(_vm.avatarColors, function (color, idx) {
                        return _c("div", {
                          key: idx + _vm.avatarIcons.length,
                          staticClass: "avatar-item",
                          class: { active: _vm.avatarColor === color },
                          style: { background: color },
                          on: {
                            click: function ($event) {
                              _vm.avatarColor = color
                            },
                          },
                        })
                      }),
                      0
                    ),
                  ]),
                ]),
                _vm._v(" "),
                _c(
                  "primary-button",
                  {
                    staticClass: "btn-confirm",
                    on: { click: _vm.handleConfirmAvatar },
                  },
                  [_vm._v("Confirm")]
                ),
              ],
              1
            )
          : _vm._e(),
      ],
      1
    ),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "profile-setting-wrapper" },
      [
        _c("rt-input", {
          ref: "username",
          attrs: { placeholder: "User Name", floatingLabel: "Username" },
          model: {
            value: _vm.userName,
            callback: function ($$v) {
              _vm.userName = $$v
            },
            expression: "userName",
          },
        }),
        _vm._v(" "),
        _c("rt-input", {
          ref: "first",
          attrs: {
            placeholder: _vm.firstNameHint,
            floatingLabel: _vm.firstNameFloatingLabel,
          },
          model: {
            value: _vm.firstName,
            callback: function ($$v) {
              _vm.firstName = $$v
            },
            expression: "firstName",
          },
        }),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "last-name-wrapper" },
          [
            _c("rt-input", {
              ref: "last",
              attrs: {
                placeholder: "Real Last Name",
                floatingLabel: "Last name",
              },
              model: {
                value: _vm.lastName,
                callback: function ($$v) {
                  _vm.lastName = $$v
                },
                expression: "lastName",
              },
            }),
            _vm._v(" "),
            _vm.nameError
              ? _c("p", { staticClass: "name-error" }, [
                  _vm._v(_vm._s(_vm.nameError)),
                ])
              : _vm._e(),
          ],
          1
        ),
        _vm._v(" "),
        _c("div", { staticClass: "setting-divider" }),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "email-wrapper" },
          [
            _c("rt-input", {
              ref: "email",
              staticClass: "input-email",
              attrs: {
                placeholder: _vm.emailHint,
                floatingLabel: _vm.emailFloatingLabel,
              },
              model: {
                value: _vm.email,
                callback: function ($$v) {
                  _vm.email = $$v
                },
                expression: "email",
              },
            }),
            _vm._v(" "),
            _vm.emailError
              ? _c("p", { staticClass: "email-error" }, [
                  _vm._v(_vm._s(_vm.emailError)),
                ])
              : _vm._e(),
          ],
          1
        ),
        _vm._v(" "),
        _vm.studentMode
          ? _c("div", { staticClass: "setting-divider" })
          : _vm._e(),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "age-field-wrapper" },
          [
            _vm.studentMode
              ? _c("rt-select", {
                  staticClass: "age-picker",
                  attrs: {
                    options: _vm.ageOptions,
                    value: _vm.ageOptionFrom(_vm.age),
                    type: "floating",
                    floatLabel: "Age",
                  },
                  on: { change: _vm.handleChangeAge },
                })
              : _vm._e(),
            _vm._v(" "),
            _vm.ageError
              ? _c("p", { staticClass: "age-error" }, [
                  _vm._v(_vm._s(_vm.ageError)),
                ])
              : _vm._e(),
          ],
          1
        ),
        _vm._v(" "),
        _c("div", { staticClass: "setting-divider" }),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "setting-timezone" },
          [
            _c("rt-select", {
              ref: "timezone",
              staticClass: "timezone-picker",
              attrs: {
                options: _vm.timeZoneOptions,
                value: _vm.selectedTimeZone,
                type: "floating",
                floatLabel: "Time Zone",
              },
              on: { change: _vm.handleChangeTimeZone },
            }),
            _vm._v(" "),
            _c("p", { staticClass: "current-timezone" }, [
              _vm._v(
                _vm._s(
                  _vm.currTimeZone
                    ? _vm.currTimeZone
                    : "No timezone currently selected"
                )
              ),
            ]),
          ],
          1
        ),
        _vm._v(" "),
        _vm._m(0),
        _vm._v(" "),
        _vm.subscriptionVisible
          ? _c("div", { staticClass: "setting-divider" })
          : _vm._e(),
        _vm._v(" "),
        _vm.subscriptionVisible
          ? _c(
              "div",
              { staticClass: "setting-subscription" },
              [
                _c("p", { staticClass: "subscription-name" }, [
                  _vm._v("Subscription Information"),
                ]),
                _vm._v(" "),
                _c(
                  "primary-button",
                  {
                    staticClass: "btn-billing",
                    on: { click: _vm.handleUpdateBilling },
                  },
                  [
                    _vm._v(
                      "Update Billing Information / View Past\n        Invoices\n      "
                    ),
                  ]
                ),
              ],
              1
            )
          : _vm._e(),
      ],
      1
    ),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "setting-panel-footer" },
      [
        _c(
          "primary-button",
          {
            staticClass: "btn-close",
            on: {
              click: function ($event) {
                return _vm.$emit("close", _vm.profileSaved)
              },
            },
          },
          [_vm._v("Close")]
        ),
        _vm._v(" "),
        _c(
          "primary-button",
          { staticClass: "btn-save", on: { click: _vm.handleSaveProfile } },
          [_vm._v("Save")]
        ),
      ],
      1
    ),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticStyle: { "text-align": "right" } }, [
      _c(
        "a",
        {
          attrs: {
            target: "_blank",
            rel: "privacy-policy",
            href: "https://readtheory.org/privacy-policy/",
          },
        },
        [_vm._v("Privacy Policy")]
      ),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }